import { render, staticRenderFns } from "./VideoWrapper.vue?vue&type=template&id=55dbe0b7&scoped=true&lang=pug"
import script from "./VideoWrapper.vue?vue&type=script&lang=ts"
export * from "./VideoWrapper.vue?vue&type=script&lang=ts"
import style0 from "./VideoWrapper.vue?vue&type=style&index=0&id=55dbe0b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dbe0b7",
  null
  
)

export default component.exports